import { CompositeDecorator } from 'draft-js';

import LinkDecorator from './LinkDecorator';
import ImageDecorator from './ImageDecorator';

const decorator = new CompositeDecorator([LinkDecorator]);

export default decorator;
